import { pgTable, text, uuid } from "drizzle-orm/pg-core";
import { createInsertSchema, createSelectSchema } from "drizzle-zod";
import z from "zod";

import { customTimestamp } from "./utils/types";

export const representativesTable = pgTable("representatives", {
  id: uuid("id").primaryKey().defaultRandom(),
  firstName: text("first_name").notNull(),
  middleName: text("middle_name"),
  lastName: text("last_name").notNull(),
  signatureDataUri: text("signature_data_uri").notNull(),
  createdAt: customTimestamp("created_at")
    .notNull()
    .$defaultFn(() => new Date().toISOString()),
  updatedAt: customTimestamp("updated_at")
    .notNull()
    .$defaultFn(() => new Date().toISOString())
    .$onUpdateFn(() => new Date().toISOString()),
});

export const representativeSchema = createSelectSchema(representativesTable);
export type RepresentativeType = z.infer<typeof representativeSchema>;

export const insertRepresentativeSchema = createInsertSchema(
  representativesTable,
).omit({
  createdAt: true,
  updatedAt: true,
});
export type InsertRepresentativeType = z.infer<
  typeof insertRepresentativeSchema
>;
